module.exports = __webpack_public_path__ + "img/empreendimento-logo-19.003759e3.png";